module.exports = __webpack_public_path__ + "static/Principal-Regular-58809836629d456e7132e821d2d7d0e7.eot";